<template>
  <div class="skeleton-map" :style="{ height: height }">
    <div v-if="showMarker" class="map-marker"></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonMap',
  props: {
    height: {
      type: String,
      default: '380px'
    },
    showMarker: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.skeleton-map {
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  position: relative;
}

.map-marker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(88, 149, 255, 0.2);
  animation: pulse 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.4;
  }
}
</style>
